import {inject, Injectable} from '@angular/core';
import {MatDialog} from "@angular/material/dialog";
import {CloseModalReason} from "../../../../core/types/modal.types";
import {
  ProductCardSyncModalComponent
} from "../components/modals/product-card-sync-modal/product-card-sync-modal.component";
import {
  ProductCardSyncDialogData
} from "../components/modals/product-card-sync-modal/types/product-card-sync-modal.types";
import {
  CompetitorArticleSyncModalComponent
} from "../components/modals/competitor-article-sync-modal/competitor-article-sync-modal.component";

@Injectable({
  providedIn: 'root'
})
export class ProductCardModalsService {
  private dialog: MatDialog = inject(MatDialog);

  public openSyncModal(data: ProductCardSyncDialogData): Promise<CloseModalReason> | void {
    const dialogRef = this.dialog.open(ProductCardSyncModalComponent, {
      data: data,
      width: '90vw',
    });

    return new Promise((resolve) =>
      dialogRef.afterClosed().subscribe((reason: CloseModalReason) => resolve(reason))
    );
  }

  public openSyncCompetitorArticleModal(productCardId: number): Promise<CloseModalReason> | void {
    const dialogRef = this.dialog.open(CompetitorArticleSyncModalComponent, {
      data: {
        productCardId: productCardId
      },
      width: '90vw',
    });

    return new Promise((resolve) =>
      dialogRef.afterClosed().subscribe((reason: CloseModalReason) => resolve(reason))
    );
  }
}
